import React, { useContext, useEffect, useState } from "react";
import {  getFinalScoreOncredit } from "services/routeServices";
import challengesAdapter, { IChallenges, ISubChallengeDTO } from "adapters/challenges.adapter";
import authContext from "shared/src/contexts/authContext";
import { findCurrentChallenge } from "utils/challengesUtils";
import { GET_CHALLENGES_MOCK } from "./data/CourseCreditsMock";
import CourseCreditsDashboard from "./course-credits-dashboard/CourseCreditsDashboard";

export interface CurrentChallengeInterface {
  challengeIndex: number;
  subChallengeIndex: number;
  challengeDTO: IChallenges;
  subChallengeDTO: ISubChallengeDTO;
}

const CourseCredits = () => {

  const context = useContext(authContext);

  const [challenges, setChallenges] = useState<IChallenges[] | null>(null);
  const [score, setScore] = useState<number | null>(null);
  const [currentChallenge, setCurrentChallenge] = useState<CurrentChallengeInterface>();

  const auth = useContext(authContext);

  const getScoreData = async () => {
    try {
      const scoreApi = (await getFinalScoreOncredit()).data.data;
      setScore(scoreApi);
    } catch (error) {
      console.error("Error al obtener la puntuación del curso.");
    }
  }

  const getUserChallenges = async () => {
    try {
      let completeChallenges;
      if (score !== -1 && score !== null) {
        completeChallenges = GET_CHALLENGES_MOCK.data.data.map(challenge => {
          return {
            ...challenge,
            subChallengeDTO: challenge.subChallengeDTO.map(subChallenge => ({
              ...subChallenge,
              completed: true
            }))
          };
        });
      }

      const storedChallengesString = localStorage.getItem('GET_CHALLENGES_USER');
      const storedChallenges = storedChallengesString ? JSON.parse(storedChallengesString) : null;

      const challengesToStore = storedChallenges === null ? (completeChallenges || GET_CHALLENGES_MOCK.data.data) : (completeChallenges || storedChallenges);
      
      localStorage.setItem('GET_CHALLENGES_USER', JSON.stringify(challengesToStore));

      const challengesToSet = challengesAdapter(challengesToStore);
      const currentChallengeToSet = findCurrentChallenge(challengesToSet);

      setChallenges(challengesToSet);
      setCurrentChallenge(currentChallengeToSet);

    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (score != null) {
      getUserChallenges()
    }
  }, [score]);

  useEffect(() => {
    getScoreData();
  }, [context.gigyaAccount]);


  return (
    <CourseCreditsDashboard challenges={challenges} setChallenges={setChallenges} currentChallengeProps={currentChallenge} />
  )
}

export default CourseCredits;
